export const reducerName = 'AUTH'

const TOGGLE = `TOGGLE_${reducerName}`
const FORM = `UPDATE_FORM_${reducerName}`

export const onAuth = () => ({ type: TOGGLE })
export const onAuthForm = (form) => ({ type: FORM, form })

